import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[locale]/page.client.tsx");
